import { render, staticRenderFns } from "./privacyDd.vue?vue&type=template&id=33e847da&scoped=true&"
import script from "./privacyDd.vue?vue&type=script&lang=js&"
export * from "./privacyDd.vue?vue&type=script&lang=js&"
import style0 from "./privacyDd.vue?vue&type=style&index=0&id=33e847da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e847da",
  null
  
)

export default component.exports